import { Typography } from '@eye-able/ui';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export function CustomPolicyHeader() {
  const { t } = useInlineTranslation();

  return (
    <div>
      <Typography tag='h1' variant='headline-xl'>
        {t('customPolicies')}
      </Typography>
      <Typography className='eye:mt-5xs eye:text-grey-120'>
        {t('customPoliciesDescription')}
      </Typography>
    </div>
  );
}
